import React from "react";

import { useNavigate } from "react-router-dom";
import WhyChooseUsimg from "../../Assets/MD.jpeg";
// import WhyChooseUsimg from "../../Assets/homeimgs/Survey.jpg";
const ProfileDetails = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 md:mx-16 mx-6 gap-10 md:mt-10 mt-5 overflow-hidden  py-10">
        <div
          className="lg:space-y-5 space-y-3 flex flex-col tracking-wide "
          data-aos="fade-right"
        >
          <h2 className="lg:text-4xl text-3xl font-bold mb-4 text-[#1522ec]">
            The Founder Person, The MD
          </h2>
          <p className="text-[#00072c] text-base text-justify ">
            I Er. S.P. Sethi (CIVIL) (M.D) Pleased to welcome you to OTL
            CONSULTANCY SERVICE PVT. LTD . Our Company Established in 2018
            Bhubaneswar (Odisha) we are providing various kind of civil
            Engineering service including Material testing , sub-soil
            Investigation , Engineer Survey (by DGPs, TS , Drone), Design of
            Building & Bridges Drawing , Design , Estimate & Preparation of road
            DPR of Roads Our team of Experts &Built and professional engineers
            are Gaining Experience From Past many Year IN the field of Civil
            Engineering.
          </p>
          <p className="text-[#00072c] text-base text-justify">
            Our Main Objectives on-time Completion Of work in 95% cases Error
            free Reporting in Stipulated Period.
          </p>
          <p className="text-[#00072c] text-base text-justify">
            We have NABL Accreditation Laboratory Named OTL CONSULTANCY SERVICE
            PVT. LTD. (IC-15304) 182 Nos Parameters in our Scope, including
            Water & Chemicals Soil , Cement , Building Materials , Rock , NDT
            ,By UPV ,Estimation of Crack Depth, RH .
          </p>
          <p className="text-[#00072c] text-base text-justify">
            We are Dedicated to these Principle in providing Quality Consulting
            Services and aspire to become a Reliable and Trustworthy consulting
            form India. I love my Company.
          </p>
          {/* <p className="text-[#00072c] text-base text-justify">
            We also pledge to nurture the young talents of the organization to
            upgrade their technical skill with deliberations, Seminar, Workshops
            and trainings.
          </p> */}
        </div>
        <div
          data-aos="fade-left"
          className="flex flex-col justify-end items-center  mx-auto"
        >
          <img
            src={WhyChooseUsimg}
            alt="Industrial port with cranes and water at dusk"
            className="h-auto md:h-[400px] lg:h-[450px]  rounded-md "
          />
          <div
            className="pt-3 text-[1rem] font-bold xl:w-[70%] w-full text-center sm:px-10 px-5 mx-auto"
            data-aos="zoom-in"
          >
            <h1 className="text-red-500 font-bold lg:text-xl">
              Er Siba prasad sethi (Civil) Managing Director
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileDetails;
